































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { QuestionHolder } from "@/components/Form.vue";

import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", required);

@Component({ components: { ValidationProvider } })
export default class Questions extends Vue {
  @Prop() private readonly value!: QuestionHolder | null;

  updateQuestions() {
    this.$emit("input", this.value);
    this.$emit("change");
  }
}
